import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
    selector: "app-table-empty-state",
    templateUrl: "./table_empty_state.component.html",
    styleUrls: ["./table_empty_state.component.css"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableEmptyStateComponent {
    @Input() message = "This table is currently empty";
    protected readonly logoPath = "assets/images/logo/logo_icon.png";
}
